import * as angular from "angular";
import { Utils } from "../../helper/utils.helper";

let SurveyResultsPageComponent = {
    selector: "vcSurveyResultsPage",
    templateUrl: "/angular/components/result/survey-result-page.component.html",
    bindings: {},
    controller: class SurveyResultsPageController {
        public sid: any;
        public utils: Utils;

        constructor($routeParams: any, Utils: Utils) {
            this.sid = $routeParams.sid;
            this.utils = Utils;
        }
    },
};

angular
    .module("result")
    .component(SurveyResultsPageComponent.selector, SurveyResultsPageComponent);
